import { Controller } from "@hotwired/stimulus"

// Opens a bottom-sheet that lives outside the trigger's ancestor chain.
//
// Wire with: data-controller="sheet-trigger"
//            data-action="click->sheet-trigger#open"
//            data-sheet-trigger-bottom-sheet-outlet="#some_sheet_id"
//
// Uses the application registry rather than Stimulus outlets so the lookup
// works even when the trigger and sheet connect on different turbo-frame
// load cycles.
export default class extends Controller {
  open()  { this.#invoke("open") }
  close() { this.#invoke("close") }

  #invoke(method) {
    const selector = this.element.dataset.sheetTriggerBottomSheetOutlet
    if (!selector) return

    const target = document.querySelector(selector)
    if (!target) return

    const controller = this.application.getControllerForElementAndIdentifier(target, "bottom-sheet")
    controller?.[method]()
  }
}
